<ng-container *ngIf="hospid">
    <div class="container-fluid">
        <h6 class="title"> Facility Demographics Summary </h6><br>
        <nav>           
            <div class="nav nav-tabs customTabber" id="nav-tab" role="tablist">

            <a class="nav-item nav-link active" id="nav-address-tab" data-bs-toggle="tab" href="#nav-address" role="tab"
                aria-controls="nav-address" aria-selected="true">Physical Facility Address</a>
            <a *ngIf="showTab" class="nav-item nav-link" id="nav-chief-nurse-tab" data-bs-toggle="tab" href="#nav-chief-nurse" role="tab"
                aria-controls="nav-chief-nurse" aria-selected="false">Chief Nurse</a>      
            <a *ngIf="showTab" class="nav-item nav-link" id="nav-magnet-tab" data-bs-toggle="tab" href="#nav-magnet" role="tab"
                aria-controls="nav-magnet" aria-selected="false">Magnet</a>
            <a *ngIf="showTab" class="nav-item nav-link" id="nav-demographics-tab" data-bs-toggle="tab" href="#nav-demographics" role="tab"
                aria-controls="nav-demographics" aria-selected="false">Demographics</a>   
            <a *ngIf="showTab" class="nav-item nav-link" id="nav-emergency-services-tab" data-bs-toggle="tab" href="#nav-emergency-services" role="tab"
                aria-controls="nav-emergency-services" aria-selected="false">Emergency Services</a> 
            <a *ngIf="showTab" class="nav-item nav-link" id="nav-perinatal-care-tab" data-bs-toggle="tab" href="#nav-perinatal-care" role="tab"
                aria-controls="nav-perinatal-care" aria-selected="false">Perinatal Care</a>
            <a *ngIf="showTab" class="nav-item nav-link" id="nav-pathway-tab" data-bs-toggle="tab" href="#nav-pathway" role="tab"
                aria-controls="nav-pathway" aria-selected="false">Pathway to Excellence®</a>
            <a *ngIf="showTab" class="nav-item nav-link" id="nav-census-tab" data-bs-toggle="tab" href="#nav-census" role="tab"
                aria-controls="nav-census" aria-selected="false">Average Daily Census</a>

            </div> 
        </nav>

        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-address" role="tabpanel" aria-labelledby="nav-address">
                <app-address>
                </app-address>
            </div>

            <div class="tab-pane fade" id="nav-chief-nurse" role="tabpanel" aria-labelledby="nav-chief-nurse-tab">                    
                <app-chief-nurse
                (showTab)="checkChiefNurseTabStatus($event)"> 
                </app-chief-nurse>
            </div>

            <div class="tab-pane fade" id="nav-magnet" role="tabpanel" aria-labelledby="nav-magnet-tab">
                <app-magnet
                (showTab)="checkMagnetTabStatus($event)" >
                </app-magnet>
            </div>

            <div class="tab-pane fade" id="nav-demographics" role="tabpanel" aria-labelledby="nav-demographics-tab">
                <app-demographics
                (showTab)="checkDemograpgicsTabStatus($event)" >
                </app-demographics>
            </div>
            
            <div class="tab-pane fade" id="nav-emergency-services" role="tabpanel" aria-labelledby="nav-emergency-services-tab">                    
                <app-emergency-services> 
                </app-emergency-services>
            </div>
            <div class="tab-pane fade" id="nav-perinatal-care" role="tabpanel" aria-labelledby="nav-perinatal-care-tab">                    
                <app-perinatal-care> 
                </app-perinatal-care>
            </div>
            <div class="tab-pane fade" id="nav-pathway" role="tabpanel" aria-labelledby="nav-pathway-tab">                    
                <app-pathway> 
                </app-pathway>
            </div>
            <div class="tab-pane fade" id="nav-census" role="tabpanel" aria-labelledby="nav-census-tab">                    
                <app-census> 
                </app-census>
            </div>
        </div> 
         
        <br>
        <!-- Buttons -->
        <div class="col-sm-10 btngroup">
            <button type="submit" tabindex="0" class="btn btn-primary btn-sm mr-3 float-left" (click)="onSave(hospid)" > Save and Continue </button>
            <button type="button" tabindex="-1" class="btn btn-primary btn-sm mr-3 float-left" (click)="onCancelUser()"> Cancel </button>
        </div>
    </div>
</ng-container>